<template>
  <div>
    <h1 class="mb-8 font-bold text-2xl">POSTES REFUSE</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="mt-4 block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null"/>
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <div class="flex">
        <button class="btn-indigo py-2.5 mr-4 flex items-center disabled:opacity-50" @click="receiveSelection" :disabled="selected.length === 0">
          <div v-if="sending" class="btn-spinner mr-2" />
          <span>Valider la selection</span>&nbsp;
        </button>
      </div>
    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-no-wrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4"><input type="checkbox" class="form-checkbox h-5 w-5" v-model="selectAll" @change="select"></th>
          <th class="px-2 pt-6 pb-4">N° Order</th>
          <th class="px-2 pt-6 pb-4">IMEI</th>
          <th class="px-6 pt-6 pb-4">Brand</th>
          <th class="px-6 pt-6 pb-4">Model</th>
          <th class="px-6 pt-6 pb-4">Panne</th>
          <th class="px-6 pt-6 pb-4">Commentaire</th>
          <th class="px-6 pt-6 pb-4">Date reception</th>
        </tr>
        <tr v-for="repair in repairs.data" :key="repair.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <div class="px-6 py-4 flex items-center focus:text-indigo-500">
              <input type="checkbox" class="form-checkbox h-5 w-5" :value="repair.id" v-model="selected">
            </div>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" href="#">
              {{ repair.id }}
              <icon v-if="repair.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2"/>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" href="#"
                          tabindex="-1">
              {{ repair.imei }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" href="#"
                          tabindex="-1">
              {{ repair.brand }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" href="#"
                          tabindex="-1">
              {{ repair.model}}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" href="#"
                          tabindex="-1">
              {{ repair.malfunction}}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" href="#"
                          tabindex="-1">
              {{ repair.comment}}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" href="#" :title="repair.creation_date"
                          tabindex="-1">
              {{ repair.created_at }}
            </inertia-link>
          </td>
        </tr>
        <tr v-if="repairs.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No reparation found.</td>
        </tr>
      </table>
    </div>
    <pagination :links="repairs.links"/>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Layouts/AppLayout'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'
import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";
import JetDangerButton from '@/Jetstream/DangerButton'


export default {
  metaInfo: {title: 'Reception Test'},
  layout: Layout,
  components: {
    Icon,
    SearchFilter,
    Pagination,
    JetDangerButton,
  },
  props: {
    repairs: Object,
    filters: Object,
  },
  data() {
    return {
      selected: [],
      selectAll: false,
      sending: false,
      form: {},
    }
  },
  watch: {
    form: {
      handler: throttle(function () {
        let query = pickBy(this.form)
        this.$inertia.replace(this.route('test.rejectedQuoteList', Object.keys(query).length ? query : {remember: 'forget'}))
      }, 150),
      deep: true,
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    select() {
      this.selected = [];
      if (this.selectAll) {
        for (let i in this.repairs.data) {
          if (this.repairs.data.hasOwnProperty(i)) {
            this.selected.push(this.repairs.data[i].id);
          }
        }
      }
    },
    receiveSelection() {
      const data = new FormData()
      data.append('ids', this.selected || [])
      this.$inertia.post(this.route('test.accept'), data, {
        preserveScroll: true,
        onStart: () => this.sending = true,
        onFinish: () => {
          this.sending = false
          this.selected = []
        }
      })
    },
    rejectSelection() {
      const data = new FormData()
      data.append('ids', this.selected || [])
      this.$inertia.post(this.route('test.reject'), data, {
        preserveScroll: true,
        onStart: () => this.sending = true,
        onFinish: () => {
          this.sending = false
          this.selected = []
        }
      })
    }
  },
}
</script>
